import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
  import drr from '@minogin/vue-drag-resize-rotate'

import VueChatScroll from 'vue-chat-scroll'
import Vuelidate from 'vuelidate'

 export const bus=new Vue()

   const fb = require('./firebase/firebaseconfig.js')
 

import Routes from './router/index.js'
  Vue.component('drr', drr)

Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(VueChatScroll)
const router=new VueRouter({

routes:Routes,
mode:'history' 

  })
 
  navigator.serviceWorker.addEventListener('message', event => {
  console.log('Push Notification Recieved') // refresh code goes here  
})

 
router.beforeEach((to,from,next)=>{
    	 
 
 
 let cu=fb.auth.currentUser;

 let ra=to.matched.some(record=>record.meta.requiresAuth)
 
   if(ra && !cu){

  next({path:'/login' })

  }else if(!ra &&  cu ){

  next()

 }else{
  next()
 }

})


 
  let app;


window.addEventListener('load', function () {
    //your script

  fb.auth.onAuthStateChanged((user)=>{
 
if(!app){


    app=new Vue({
  el: '#app',
  render: h => h(App),
  router:router
})
  }


  })


  })




// WEBPACK FOOTER //
// ./src/main.js